import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'; // O cualquier otra librería de fechas (dias, momento...)
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { format } from 'date-fns'; // Para formatear la fecha
// NOTA: Habrá que importar también el componente TextField de @mui/material a TaskDueDate.js
import TextField from '@mui/material/TextField';

// Recibe el ID, la fecha actual y la función de actualización
const TaskDueDate = ({ taskId, dueDate, onUpdateTaskDate }) => {

    // Si dueDate existe, la pareja como objeto Date
    const dateValue = dueDate ? new Date(dueDate) : null;

    // La función que se ejecuta al seleccionar una nueva fecha
    const handleDateChange = (newDate) => {
        onUpdateTaskDate(taskId, newDate);
    };

    return (
        <div style={{ marginLeft: '10px' }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    label="Fecha Límite"
                    value={dateValue}
                    onChange={handleDateChange}
                    renderInput={(params) => <TextField {...params} size="small" />} // Renderizado con TextField de MUI
                />
            </LocalizationProvider>
            {/* Opcionalmente, mostrar la fecha formateada si no estamos editando */}
            {dueDate && <p>Límite: {format(dateValue, 'dd/MM/yyyy')}</p>}
        </div>
    );
};

export default TaskDueDate;